import httpClient from '../../services/http-client';
import { API_SUB_URL_DOCTOR } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_DOCTOR, LOAD_LIST_DOCTOR, LOAD_A_DOCTOR, UPDATE_A_DOCTOR, DELETE_A_DOCTOR
} from '../actionTypes';

export const apiLoadListDoctor = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_DOCTOR}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_DOCTOR, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadADoctor = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_DOCTOR}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_DOCTOR, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewDoctor = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_DOCTOR, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_DOCTOR, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateADoctor = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_DOCTOR}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_DOCTOR, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteADoctor = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_DOCTOR}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_DOCTOR, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};